import { useSelector } from 'react-redux'

import { storyPaths } from './storyPaths.js'
import StoryScene from './storyPath/StoryScene.js'
import OpeningSceneScene from './opening_scene/components/OpeningSceneScene.js'
import { selectIsOpeningSceneComplete } from './opening_scene/openingSceneSlice.js'

export default function Scenes () {
  const isOpeningSceneComplete = useSelector(selectIsOpeningSceneComplete)

  if (!isOpeningSceneComplete) return <OpeningSceneScene />

  return (
    <>
      {storyPaths.map(({ key, slice, icon }) => (
        <StoryScene key={key} slice={slice} storyIcon={icon} />
      ))}
    </>
  )
}
